awardData.classy.controller({
    name: 'AwardDataVehiclesController',
    inject: ['$scope', 'ApplicationService', 'authServiceFactory', 'VehicleModelFactory', 'SchoolModelService', 'CalculationService'],
    init: function()
    {
        this.$.authServiceFactory = this.authServiceFactory;
        this.familyIndex = this.ApplicationService.getFamilyIndex();
        this.model = new this.VehicleModelFactory(this.ApplicationService.getFamilyData().data[0].familyID);
        this.initOpened();
        this.$.familyIndex = this.ApplicationService.getFamilyNo();
        this.$.ApplicationService = this.ApplicationService;
        this.$.versionNo = versionNo;
        this.$.items = this.model.get();
        this.$.showEdit = false;
        this.$.compare = false;
        this.$.yesNo = {0: 'No', 1: 'Yes'};
        this.$.School_Country = this.SchoolModelService.get()[0].School_Country;
        
        for (var i = 0; i < this.$.items.length; i++)  {
            this.$.items[i].active = (i==0) ? true : false
        }
        this.$.isEdited = [];
        for (var j = 0; j < this.$.items.length; j++) {
            if (this.$.items[j].Veh_Debt_Out==this.$.items[j].xVeh_Debt_Out && this.$.items[j].Veh_EMV==this.$.items[j].xVeh_EMV &&
                this.$.items[j].Veh_Lease==this.$.items[j].xVeh_Lease && this.$.items[j].Veh_Make==this.$.items[j].xVeh_Make &&
                this.$.items[j].Veh_Payment==this.$.items[j].xVeh_Payment && this.$.items[j].Veh_Year==this.$.items[j].xVeh_Year) {
                this.$.isEdited[j] = false;
            }
            else {
                this.$.isEdited[j] = true;
            }
        }
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
    },
    watch: {
        'this.SliderService.returnSliders()': function(oldValue, newValue) {
            if (this.$.SliderService.returnSliders().length>0) {
                for (var j = 0; j < this.$.SliderService.returnSliders().length; j++) {
                    if (this.$.SliderService.returnSliders()[j].partial.indexOf("ehicle") >= 0)
                        var ind = this.$.SliderService.returnSliders()[j].paramObj.tab
                }
                for (var i = 0; i < this.$.items.length; i++) {
                    if (ind!==undefined) {
                        this.$.items[ind].active = true;
                    }
                    else {
                        this.$.items[i].active = false;
                    }
                }
            }
        }
    },
    initOpened: function()
    {
        this.opened = Array();
        this.edited = Array();
        for (var i = 0; i < this.$.items.length; i++) {
            this.opened[i] = false;
            this.edited[i] = false;
            this.$.items[i].deleted = 0;
        }
    },
    toggleOpen: function(index)
    {
        if (this.opened[index] == false)
            this.initOpened();
        this.opened[index] = !this.opened[index];
    },
    getOpened: function(index)
    {
        return this.opened[index];
    },
    dismiss: function()
    {
        this.ApplicationService.getFamilyData().vehicle.pop();
    },
    getEdited: function(index)
    {
        return this.edited[index];
    },
    newVehicle: function($event)
    {
        $event.preventDefault();
        $event.stopPropagation();
        var ind = this.model.new();
        this.$.items = this.ApplicationService.getFamilyData().vehicle;
        this.$.items[ind].active = 1;
        this.initOpened();
        this.toggleEdit(ind);
    },
    toggleEdit: function(index)
    {
        if (this.edited[index] == false)
            this.initOpened();
        this.edited[index] = !this.edited[index];
    },
    getField: function(item, field)
    {
        if (item['x' + field] === null || item[field] == item['x' + field])
            return item[field]
        else
            return item['x' + field];
    },
    setCompare: function(value)
    {
        this.$.compare = value;
    },
    startSaveProcess: function(scope, instance, form, index)
    {
        this.$.index = index;
        if (form.$valid)
        {
            this.edited[index] = !this.edited[index];
            instance.options.factor = .5;
            this.$.putObject = this.$.items[index];

            if (typeof this.$.putObject.recordID !== 'undefined')
                return this.model.put(this.$.putObject.recordID, this.$.putObject, instance)
            else
                return this.model.post(this.id, this.$.putObject, instance)
        }   
        else
            instance.stop(-1);
    },
    startDeleteProcess: function(scope, instance, form, index)
    {
        this.$.index = index;
        if (form.$valid)
        {
            instance.options.factor = .5;
            this.$.items[index].deleted = 1;
            return this.model.purge(this.$.items[index].recordID, this.$.items[index], instance)
        }
        else
            instance.stop(-1);
    },
    successSave: function (scope, instance, index, callback)
    {
        this.edited[index] = !this.edited[index];
        var parent = this;
        if(instance.options.config.method == "POST")
        {
            this.$.items[index].recordID = instance.options.data.id;
        }
        this.model.updateData();
        this.CalculationService.reCalc();
        if (typeof callback != 'undefined')
            callback();
    },
    successDelete: function (scope, instance, index)
    {
        this.$.items.splice(index, 1);
        this.edited[index] = !this.edited[index];
        this.initOpened();
        this.CalculationService.reCalc();
        //this.ApplicationService.getFamilyData().vehicle.splice(index, 1);
    }
});
